import DataStudio from "./DataStudio";

export default DataStudio;
